// Footer.js
import React from 'react';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faLinkedinIn, faGithub, faInstagram, } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Company Info Section */}
        <div className="footer-column">
          <h2>DEVELOPED BY GIDEON</h2>
          <p>We specialize in creating beautiful, responsive websites tailored to your business needs. Let’s bring your vision to life.</p>
        </div>

        {/* Quick Links Section */}
        <div className="footer-column">
          <h2>Quick Links</h2>
          <ul>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Social Media Section */}
        <div className="footer-column">
          <h2>Follow Us</h2>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faTwitter} /></a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedinIn} /></a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faGithub} /></a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
          </div>
        </div>
      </div>
      
      {/* Copyright Section */}
      <div className="footer-bottom">
        <p>&copy; 2024 DEVELOPED BY GIDEON. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
